module.exports = __webpack_public_path__ + "static/equipment-truck-8abde78d051632d42feadf879dc1aa4f.jpg";